// lightTheme.js
import { TONES, toneVars } from "./tones";

const lightTheme = {
  name: "light",
  colors: {
    "--color-bg-secondary": "255 255 255",
    "--color-bg-primary": "245 246 248",
    "--color-bg-tertiary": "236 238 241",
    "--color-bg-form": "250 251 252",
    "--color-bg-icon": "232 235 239",
    "--color-bg-invert": "34 34 34",

    "--color-text-primary": "24 24 27",
    "--color-text-secondary": "82 82 91",
    "--color-text-tertiary": "255 255 255",
    // #696972. Was #71717A, which measured 4.16:1 on `bg-background-tertiary` —
    // under the 4.5:1 body text needs, and this token carries helper text,
    // timestamps and hints all over the app. Measured against the four surfaces
    // text sits on (primary, secondary, tertiary, form); tertiary is the tightest
    // and now clears at 4.68:1.
    "--color-text-muted": "105 105 114",
    "--color-text-base": "255 255 255",
    "--color-text-blue": "24 95 170",
    "--color-text-invert": "255 255 255",

    "--color-primary-border": "214 217 222",

    // The boundary of a control you can type into, and a separate token from
    // `--color-primary-border` on purpose. A card's outline is decorative — the
    // fill already says where the card is — but a text field on a white card has
    // no fill of its own, so its border is the only thing saying the field is
    // there. WCAG 1.4.11 puts that at 3:1, and #D6D9DE managed 1.18:1.
    //
    // #7C828D, 3.32:1 against the tightest surface an input sits on. Darkening
    // `--color-primary-border` to reach the same bar would have put a heavy
    // outline around every card and modal in the app, which is not what the rule
    // asks for.
    "--color-input-border": "124 130 141",

    "--color-gradient-border": "linear-gradient(90deg, #F5F5F5, #D3D3D3)",
    "--color-green-border": "linear-gradient(135deg, #A8D5BA, #E0E0E0)",
    "--color-yellow-border": "linear-gradient(135deg, #E6D37A, #E0E0E0)",
    "--color-pink-border": "linear-gradient(135deg, #C24471 0%, transparent 60%)",

    "--color-tech-stack-1": "linear-gradient(90deg,#F9F9F9, #A6BEE0)",
    "--color-tech-stack-2": "linear-gradient(90deg, #F0F0F0, #C4A1A1)",
    "--color-tech-stack-3": "linear-gradient(90deg, #F0F0F0, #DDCD90)",
    "--color-tech-stack-4": "linear-gradient(90deg, #F0F0F0, #87AA92)",
    "--color-tech-stack-5": "linear-gradient(90deg, #F0F0F0, #A786B4)",
    "--color-tech-stack-6": "linear-gradient(90deg, #F0F0F0, #D09D81)",
    "--color-tech-stack-7": "linear-gradient(90deg, #F0F0F0, #CC8788)",
    "--color-tech-stack-8": "linear-gradient(90deg, #F0F0F0, #D474C7)",
    "--color-tech-stack-9": "linear-gradient(90deg, #F0F0F0, #999999)",

    "--color-btn-primary": "34 34 34",
    "--color-btn-secondary": "24 95 170",
    "--color-btn-tertiary": "232 235 239",

    "--color-sidebar-text": "82 82 91",
    "--color-sidebar-hover-text": "24 24 27",
    "--color-sidebar-hover-bg": "236 238 241",
    "--color-sidebar-test": "249 249 249",

    "--color-table-bg": "248 249 251",
    "--color-table-heading": "236 238 241",

    "--color-scrollbar-track": "240 242 245",
    "--color-scrollbar-thumb": "190 195 201",
    "--color-scrollbar-thumb-hover": "145 150 156",

    "--color-accent-soft": "79 70 229",
    "--color-accent-border": "79 70 229",
    "--color-accent-text": "67 56 202",

    "--color-calendar-selected-bg": "34 34 34",
    "--color-calendar-selected-text": "255 255 255",


    // ───────────────── Status ─────────────────
    // `text-status-error`, `bg-status-success` and the raw
    // `rgb(var(--color-error))` arbitrary values all resolve through these.
    // They were referenced across six screens while being defined nowhere:
    // `rgb(var(--color-error) / 1)` with the variable unset is an invalid
    // colour, so every one of those elements silently inherited its parent's
    // text colour instead of turning red.
    //
    // Sourced from TONES rather than picked fresh, because those eight values
    // are the ones whose contrast against their own soft fill is measured (see
    // tones.js). One hue, one pair of numbers, both themes.
    "--color-error": TONES.rose.fg.light,
    "--color-success": TONES.emerald.fg.light,
    "--color-warning": TONES.amber.fg.light,
    "--color-info": TONES.blue.fg.light,

    ...toneVars("light"),
  },
};

export default lightTheme;